// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';

import AccountDetails from 'app/viewport/components/AccountDetails';
import AccountUsage from 'app/viewport/components/AccountUsage';
import DropdownMenu from 'app/common/components/DropdownMenu';
import { BASE_APP_URL as DEV_PATH } from 'app/developer-v3/utils/constants';
import { MenuSection } from 'app/common/components/Menu';

const accountDropdownCss = {
  maxHeight: '75vh',
  textAlign: 'left', // fight some legacy styles that `center`
  width: '270px',

  '@media (max-width: 750px)': {
    width: '90vw',
  },
};

const detailsItemsSectionCss = {
  ul: {
    maxHeight: 'initial', // Without this, the trial upgrade call to action button is hidden due to vertical scrolling.
  },
};

export type AccountDropdownProps = {
  email: string,
  isDeveloper: boolean,
  isPaid: boolean,
  isPlanMetered: boolean,
  isTrialing: boolean,
  nextPlanTier?: any,
  numFreeTasksMax: number,
  numLiveZaps: number,
  numLiveZapsMax: number,
  numTasks: number,
  numTasksMax: number,
  planName: string,
  onChoose: () => void,
  onClickOutside: () => void,
  onUpgradeClick: () => void,
  resetDate: string,
  trialDaysLeft: number,
};

const AccountDropdown = (props: AccountDropdownProps) => {
  const onLogout = () => {
    if (window.Backbone) {
      window.Backbone.cache.reset();
    }
  };

  const detailsItems = [
    {
      Item: choiceProps => (
        <AccountDetails
          email={props.email}
          isTrialing={props.isTrialing}
          onUpgradeClick={props.onUpgradeClick}
          planName={props.planName}
          trialDaysLeft={props.trialDaysLeft}
          {...choiceProps}
        />
      ),
      hasCustomChoiceHandlers: true,
      href: props.isPaid ? '/app/settings/billing' : '/app/billing/plans',
      label: props.isPaid ? 'Manage Subscription' : 'Upgrade',
    },
  ];

  const navItems = [
    {
      href: '/app/settings',
      icon: 'cog-gear',
      label: 'Settings',
    },
    {
      href: props.isDeveloper ? DEV_PATH : '/developer',
      icon: 'test',
      label: 'Developers',
    },
    {
      href: '/logout',
      icon: 'power',
      label: 'Log out',
      onClick: onLogout,
    },
  ];

  return (
    <DropdownMenu
      css={accountDropdownCss}
      kind="below justify-right block"
      onChoose={props.onChoose}
      onClickOutside={props.onClickOutside}
    >
      <MenuSection css={detailsItemsSectionCss} items={detailsItems} />
      <AccountUsage {...props} />
      <MenuSection items={navItems} />
    </DropdownMenu>
  );
};

export default AccountDropdown;
